import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "subtitle", "titleIcon", "accent", "actions", "expandable", "horizontal", "children", "imageSrc", "imageMaxWidth", "imageMaxHeight", "size", "isQuiet", "clickable", "style", "className", "transparent", "truncateHeading"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { grid, msGrid, container, preview, header, content, footer, sections, orientation, transparentBackground } from './EzCard.styles';
import EzButton from '../EzButton';
import EzCardSection from './EzCardSection';
import EzCardHeading from './EzCardHeading';
import { clsx, filterValidProps, responsiveProps } from '../../utils';
import { SlotProvider, containsChild, hasContentSlot } from '../../utils/slots';
import { EzFooter, EzHeader, EzPreview } from '../EzContent';
var hasCardSection = function hasCardSection(children) {
  return containsChild(children, 'EzCardSection');
};
var unitlessToPx = function unitlessToPx(value) {
  return typeof value === 'number' ? "".concat(value, "px") : value;
};
var EzCard = function EzCard(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    titleIcon = _ref.titleIcon,
    accent = _ref.accent,
    actions = _ref.actions,
    expandable = _ref.expandable,
    isHorizontal = _ref.horizontal,
    children = _ref.children,
    imageSrc = _ref.imageSrc,
    maxWidth = _ref.imageMaxWidth,
    maxHeight = _ref.imageMaxHeight,
    size = _ref.size,
    isQuiet = _ref.isQuiet,
    clickable = _ref.clickable,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    className = _ref.className,
    transparent = _ref.transparent,
    truncateHeading = _ref.truncateHeading,
    props = _objectWithoutProperties(_ref, _excluded);
  var _responsiveProps = responsiveProps(props, true, 'imagePosition'),
    _responsiveProps$imag = _responsiveProps.imagePosition,
    imagePosition = _responsiveProps$imag === void 0 ? 'top' : _responsiveProps$imag;
  return React.createElement("section", _extends({}, filterValidProps(props), {
    className: clsx(className, grid({
      imagePosition: imagePosition
    }), msGrid(unitlessToPx(maxWidth))({
      imagePosition: imagePosition
    }), container({
      accent: accent,
      size: size || (isQuiet ? 'small' : undefined),
      isQuiet: isQuiet,
      clickable: clickable
    }), transparent && transparentBackground()),
    style: _objectSpread(_objectSpread({}, style), {}, {
      '--sizes-card-preview-max-w': unitlessToPx(maxWidth)
    })
  }), React.createElement(SlotProvider, {
    slots: {
      preview: {
        className: preview({
          position: imagePosition
        })
      },
      header: {
        className: header()
      },
      content: {
        className: content()
      },
      footer: {
        className: footer()
      }
    }
  }, imageSrc && React.createElement(EzPreview, null, React.createElement("img", {
    src: imageSrc,
    alt: "",
    style: {
      maxHeight: maxHeight,
      maxWidth: maxWidth,
      objectFit: 'cover'
    }
  })), title && React.createElement(EzHeader, null, React.createElement(EzCardHeading, {
    actions: actions,
    title: title,
    subtitle: subtitle,
    titleIcon: titleIcon,
    truncateHeading: truncateHeading
  })), hasContentSlot(children) ? children : React.createElement("div", {
    className: clsx(sections(), orientation({
      layout: isHorizontal ? 'horizontal' : 'vertical'
    }))
  }, hasCardSection(children) ? children : React.createElement(EzCardSection, null, children)), expandable && React.createElement(EzFooter, null, React.createElement(EzButton, {
    variant: "text",
    onClick: expandable.onClick
  }, expandable.isExpanded && expandable.collapseLabel ? expandable.collapseLabel : expandable.expandLabel))));
};
EzCard.displayName = 'EzCard';
export default EzCard;